import React from 'react';
import { usagePercent } from '../../utils/enterpriseUi';

export default function EntMeter({ label, used = 0, total = 0, hint, tone }) {
  const percent = usagePercent(used, total);
  const full = total > 0 && used >= total;
  const resolvedTone = tone || (full ? 'warn' : percent >= 80 ? 'warn' : 'ok');

  return (
    <div className="ent-meter">
      <div className="ent-meter-head">
        <span className="ent-meter-label">{label}</span>
        <span className="ent-meter-count">
          <strong>{used}</strong>
          <span> / {total || 0}</span>
        </span>
      </div>
      <div
        className={`ent-meter-track ent-meter-${resolvedTone}`}
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={Math.max(total, 0)}
        aria-valuenow={used}
      >
        <span className="ent-meter-fill" style={{ width: `${percent}%` }} />
      </div>
      {hint ? <p className="ent-meter-hint">{hint}</p> : null}
    </div>
  );
}
